import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

// Helper function to get the start and end of a month
const getMonthStartAndEnd = (
  date: Date,
): { startDate: string; endDate: string } => {
  const year = date.getFullYear();
  const month = date.getMonth();

  // Start of month (1st day at 00:00:00)
  const startDate = new Date(year, month, 1);

  // End of month (last day at 23:59:59)
  const endDate = new Date(year, month + 1, 0);

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};

export const payAllInstallmentsOperation = async (
  selectedMonth: Date | null,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
): Promise<boolean> => {
  if (!selectedMonth) {
    toast.warn('יש לבחור חודש לפני ביצוע הפעולה');
    return false;
  }

  try {
    setLoading(true);

    const { startDate, endDate } = getMonthStartAndEnd(selectedMonth);

    const res = await appApi.payAllInstallments(startDate, endDate);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('כל התשלומים נגבו בהצלחה');
    setLoading(false);
    onSuccess();
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
